import { render, staticRenderFns } from "./FieldsetPrefecturesParts.vue?vue&type=template&id=d075e238&scoped=true"
import script from "./FieldsetPrefecturesParts.vue?vue&type=script&lang=ts"
export * from "./FieldsetPrefecturesParts.vue?vue&type=script&lang=ts"
import style0 from "./FieldsetPrefecturesParts.vue?vue&type=style&index=0&id=d075e238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d075e238",
  null
  
)

export default component.exports